import { useSelector } from 'react-redux';
import { selectStatisticsByStatus } from 'ducks/trips';
import { TableComponent } from '../../common';
import React from 'react';
import i18next from 'i18next';
import { VehicleTypes } from 'ducks/vehicles/common/types';
import { Container } from './Container';
import { FetchedTrip } from 'ducks/trips/types';
import { useTranslation } from 'react-i18next';

export const NumberByStatus = () => {
    const statistics = useSelector(selectStatisticsByStatus);
    const { t } = useTranslation();

    const columns = React.useMemo(
        () => [
            {
                title: i18next.t('tripList.status'),
                field: 'status',
                sorting: false,
                render: (rowProps: FetchedTrip) =>
                    i18next.t(`scooterStatuses.${rowProps.status}`),
            },
            {
                title: i18next.t('tripList.bike'),
                field: VehicleTypes.BIKE,
                sorting: false,
            },
            {
                title: i18next.t('tripList.vae'),
                field: VehicleTypes.VAE,
                sorting: false,
            },
            {
                title: i18next.t('tripList.scooter'),
                field: VehicleTypes.SCOOTER,
                sorting: false,
            },
        ],
        [],
    );
    return (
        <TableComponent
            title={t('homePage.numberOfVehicles')}
            columns={columns}
            data={statistics || []}
            container={Container}
            pageSize={statistics?.length}
        />
    );
};
